import { useMemo } from "react";
import { usePathname, useParams } from "next/navigation";

export const usePathnameWithLocal = () => {
    const params = useParams();
    const pathname = usePathname();

    return useMemo(() => {
        const pathnameWithoutLocale = pathname.replace(`/${params.lang}`, "");
        const pathnameValues = pathnameWithoutLocale.split("/").filter((v) => Boolean(v));
        const path = `/${pathnameValues.join("/")}`;

        return {
            pathnameWithoutLocale,
            pathname,
            pathnameValues: path.split("/").filter((v) => Boolean(v)),
            lang: params?.lang as string,
        };
    }, [params.lang, pathname]);
};
